import type { CityConfig } from "../city-template/types";

export const codyConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Cody",
  state: "Wyoming",
  stateAbbr: "WY",
  slug: "cody",
  route: "/cody",
  title: "Emergency Passport Cody, WY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Cody, WY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Yellowstone travelers, Park County families, Buffalo Bill Center visitors, and Big Horn Basin communities.",
  h1: "Emergency & Expedited Passport Services in Cody, Wyoming",
  heroSubtitle: "Yellowstone-bound traveler with an expired passport? Buffalo Bill Center staff heading to an international museum conference? Park County rancher with an overseas agricultural exchange? We help Cody residents — from Sheridan Avenue business owners to East Yellowstone Valley families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Cody%20Wyoming%20downtown%20Sheridan%20Avenue%20with%20the%20historic%20Irma%20Hotel%20and%20Buffalo%20Bill%20Center%20of%20the%20West%20museum%20complex%20visible%2C%20the%20Shoshone%20River%20winding%20through%20town%20with%20dramatic%20Absaroka%20Mountains%20rising%20in%20the%20background%2C%20the%20iconic%20Cody%20Nite%20Rodeo%20grounds%20under%20golden%20sunset%20light%2C%20western%20frontier%20town%20atmosphere%20with%20wide%20streets%20and%20mountain%20views%2C%20professional%20travel%20photography%20with%20warm%20tones&width=1800&height=700&seq=cody-hero-2026&orientation=landscape",
  heroImageAlt: "Cody Wyoming downtown Sheridan Avenue with Buffalo Bill Center and Absaroka Mountains",
  geoPosition: "44.5263;-109.0565",
  geoPlacename: "Cody, Wyoming",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Nearest regional passport agency — located approximately 450 miles from Cody via US-14/US-20 and I-25; a 7+ hour drive one way",
  },
  nearbyCitiesZips: [
    { name: "Cody", zips: "82414" },
    { name: "Powell", zips: "82435" },
    { name: "Meeteetse", zips: "82433" },
    { name: "Greybull", zips: "82426" },
    { name: "Lovell", zips: "82431" },
    { name: "Thermopolis", zips: "82443" },
    { name: "Worland", zips: "82401" },
    { name: "Buffalo", zips: "82834" },
  ],
  benefits: [
    { icon: "ri-landscape-line", title: "Yellowstone National Park Gateway", desc: "Cody is the eastern gateway to Yellowstone — 52 miles from the East Entrance. Millions of international visitors pass through each year, and many Cody residents work in tourism, hospitality, and outdoor recreation industries that require international travel." },
    { icon: "ri-building-2-line", title: "Buffalo Bill Center of the West", desc: "The Buffalo Bill Center of the West is one of the nation's premier museum complexes, hosting five museums under one roof. Museum professionals, researchers, and traveling exhibit coordinators regularly travel internationally for conferences and cultural exchanges." },
    { icon: "ri-flight-takeoff-line", title: "Yellowstone Regional Airport (COD)", desc: "COD offers direct flights to Denver and Salt Lake City, connecting Cody travelers to international gateways. Seasonal service and limited flight schedules mean advance passport planning is essential for Cody residents." },
    { icon: "ri-sun-line", title: "Tourism & Hospitality Economy", desc: "Cody's economy is built around tourism — from the Cody Nite Rodeo to guided Yellowstone tours to the Irma Hotel. Hospitality professionals and tourism operators traveling internationally need reliable passport services that accommodate seasonal work schedules." },
    { icon: "ri-road-map-line", title: "Big Horn Basin Coverage", desc: "Cody serves as the commercial hub for the entire Big Horn Basin region, including Powell, Meeteetse, Greybull, Lovell, and Thermopolis. We serve all Park County and Big Horn County communities." },
  ],
  internalLinks: [
    { name: "Expedited passport in Powell, WY", route: "/cody" },
    { name: "Fast passport in Sheridan, WY", route: "/sheridan-wy" },
    { name: "Quick passport in Billings, MT", route: "/billings" },
    { name: "Wyoming passport services overview", route: "/states/wyoming" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Cody via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 7+ hours to Colorado. Cody residents can ship from any UPS Store, FedEx Office, or post office location across Park County.",
  fpcOfficeDistance: "Serving Cody, Powell, Meeteetse, Greybull, Lovell, Thermopolis, and all Big Horn Basin communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Cody and Park County. From historic Sheridan Avenue to the Buffalo Bill Center, from the Cody Nite Rodeo grounds to Yellowstone Regional Airport — we serve the entire Cody region including all Big Horn Basin communities. Our courier service eliminates the need to drive 7+ hours to Denver.",
  nearbyCitiesIntro: "We serve Cody and surrounding Park County communities including Powell, Meeteetse, Greybull, Lovell, and Thermopolis. We also serve Yellowstone National Park employees, Buffalo Bill Center staff, and Big Horn Basin residents throughout north-central Wyoming.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Cody as simple as possible — with the reliability Yellowstone tourism professionals, Park County ranchers, and Big Horn Basin families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee.",
  mistakesIntro: "Cody travelers encounter unique passport issues — from seasonal tourism work schedules to Cody Regional Airport flight connections to rural Park County documentation. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Cody travelers — from Yellowstone tour operators to Buffalo Bill Center curators to Park County ranch families — trust us when their international departure is days away and Denver is simply not an option.",
  faqIntro: "Have questions about expedited passports in Cody, WY? Here are the most common ones we hear from Park County and Big Horn Basin travelers.",
  statePageRoute: "/states/wyoming",
  statePageName: "Wyoming",
  servicesIntro: "Whether you need a renewal before a Yellowstone gateway international trip, an emergency passport for a last-minute tourism conference, or a first-time passport for a Park County family vacation — Fast Passport Center handles it with reserved courier submission availability.",
  dmvWebsite: "https://www.dot.state.wy.us/driverservices",
  dmvLabel: "Wyoming Department of Transportation — Driver Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver or SLC trip needed", "Ideal for tourism pros and Park County families", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned international travel", "Document review included", "Dedicated agent assigned to your case"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 450 miles from Cody", "7+ hour drive — impractical for Park County residents"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Yellowstone tour operator with a last-minute international booking? Family emergency abroad for a Park County resident? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Cody travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Cody residents renew fast — no agency visit required. Perfect for Yellowstone tourism professionals and Big Horn Basin frequent travelers.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Park County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed so your trip stays on track.",
      bullets: ["DS-64 form guidance", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions for your Cody family trip abroad.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Cody WY", description: "Urgent passport processing for Cody Wyoming travelers." },
    { name: "Expedited Passport Renewal Cody WY", description: "Fast passport renewal for Cody residents." },
    { name: "First-Time Passport Cody WY", description: "New passport application services for Cody residents." },
    { name: "Child Passport Cody WY", description: "Minor passport services for Cody families." },
    { name: "Name Change Passport Cody WY", description: "Name correction for Cody residents." },
  ],
  testimonials: [
    {
      name: "Tom W.",
      location: "Cody",
      rating: 5,
      text: "I guide Yellowstone tours and got a last-minute request for an international photography client — needed a passport renewal with 8 days notice. Fast Passport Center had it back in 5 days. Driving 450 miles to Denver was completely unrealistic with my tour schedule. Essential service for Cody tourism professionals.",
      service: "Passport Renewal — Rush",
    },
    {
      name: "The Mitchell Family",
      location: "Cody",
      rating: 5,
      text: "We planned a family trip to Banff and realized three of us had expired passports. Fast Passport Center handled all three — the document review caught an issue with one photo that would have caused rejection. All three passports arrived in 7 days. Incredible service from the Big Horn Basin.",
      service: "Family Passport Services",
    },
    {
      name: "Sarah K.",
      location: "Powell",
      rating: 5,
      text: "Northwest College professor with a conference in Edinburgh. My passport expired during the semester and I didn't notice. Fast Passport Center renewed it in 4 days. Shipped from the Powell post office. Saved my conference presentation.",
      service: "Expedited Renewal",
    },
    {
      name: "Bill H.",
      location: "Meeteetse",
      rating: 5,
      text: "Park County rancher heading to an agricultural exchange in Australia. No idea how to get a passport from Meeteetse. Fast Passport Center walked me through every step — from the Cody post office acceptance to the final delivery. Had my passport in 6 days. For rural Wyoming, this is the only realistic option.",
      service: "New Passport — Rush",
    },
  ],
  facilities: [
    {
      id: "cody-1",
      name: "Cody Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1301 Stampede Ave",
      city: "Cody",
      state: "WY",
      zip: "82414",
      phone: "(307) 527-7161",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Central Cody",
      website: "https://tools.usps.com/find-location.htm?location=1378491",
      websiteLabel: "USPS Location",
      notes: "Main passport acceptance facility for Cody and Park County. Limited appointment availability during summer tourist season — book 2-3 weeks ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "cody-2",
      name: "Park County Clerk — Cody",
      type: "County Clerk Passport Acceptance",
      address: "1002 Sheridan Ave",
      city: "Cody",
      state: "WY",
      zip: "82414",
      phone: "(307) 527-8620",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Cody — Park County Courthouse",
      website: "https://www.parkcounty-wy.gov/",
      websiteLabel: "Park County Website",
      notes: "County clerk office providing passport acceptance. Convenient downtown Sheridan Avenue location. Appointment recommended during summer months.",
      icon: "ri-government-line",
    },
    {
      id: "cody-3",
      name: "Powell Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "133 N Bent St",
      city: "Powell",
      state: "WY",
      zip: "82435",
      phone: "(307) 754-3411",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Powell — about 25 miles northeast of Cody",
      website: "https://tools.usps.com/find-location.htm?location=1378520",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for northern Park County and Powell area residents. Convenient for Northwest College students and Shoshone River Valley communities.",
      icon: "ri-mail-line",
    },
    {
      id: "cody-4",
      name: "Billings Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2602 1st Ave N",
      city: "Billings",
      state: "MT",
      zip: "59101",
      phone: "(406) 657-5764",
      hours: "Mon–Fri 8:30 AM – 4:30 PM (appointment required)",
      distance: "Billings — about 100 miles northeast of Cody via MT-72 and I-90",
      website: "https://tools.usps.com/find-location.htm?location=1377474",
      websiteLabel: "USPS Location",
      notes: "Larger facility with more appointment availability and photo services. About 1.5 hours from Cody — useful as backup when Cody facilities are booked during tourist season.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 450 miles and 7+ hour drive from Cody", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO; 14+ hour round trip from Cody", fpc: "Most Cody travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission as registered courier" },
    { feature: "Practicality for Cody Residents", agency: "450 miles to Denver — completely impractical for Park County", fpc: "Entirely remote — ship from Cody, receive at your door" },
    { feature: "Cost vs Resellers", agency: "Government fees — plus travel costs and days off work", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Yellowstone Tourist Season Rush",
      description: "Cody's summer tourist season (June–September) floods the acceptance facilities with applications. The Cody Post Office and Park County Clerk's office book up fast. Plan ahead and schedule your acceptance appointment 2-3 weeks before you need to ship documents.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Cody Regional Airport Flight Limitations",
      description: "Yellowstone Regional Airport (COD) offers limited daily flights to Denver and Salt Lake City. If your flight is cancelled or delayed, your international connection may be affected. Build buffer time into your passport timeline — especially during winter when flights are more frequently disrupted.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Rural Route Addressing Issues",
      description: "Many Cody and Park County residents use rural route addresses that may differ from what appears on supporting documents. Mismatched addresses can cause application delays. We review all documentation to catch address discrepancies before submission.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming SLC Is Close Enough for Agency Appointment",
      description: "Salt Lake City is about 350 miles from Cody — a 5.5 hour drive. Denver is 450 miles — a 7+ hour drive. Neither is a realistic day trip when you factor in appointment times, mountain driving conditions, and the return trip. Our courier service eliminates both drives entirely.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether a Yellowstone tourism conference, Park County family trip, or Cody business travel." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your situation — tourism professional, Buffalo Bill Center staff, or Park County rancher." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Cody clients ship from the Cody Post Office on Stampede Avenue or the UPS Store on Sheridan Avenue." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our processing center. We submit through reserved agency slots — so Cody travelers never need to drive to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is completed within your selected timeframe and shipped directly to your Cody or Park County address. No agency visit. No Denver. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Cody, Wyoming?", a: "We offer Cody-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. The nearest regional passport agency is Denver (450 miles away) — a 7+ hour drive. Our remote courier service is the only practical fast option." },
    { q: "Do I need to visit a Cody office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Cody Post Office or Park County Clerk), then ship documents overnight. We handle the State Department submission and return your passport to your Park County address." },
    { q: "Where can I get passport acceptance near Cody?", a: "Cody has acceptance facilities at the Main Post Office on Stampede Avenue and the Park County Clerk at the courthouse on Sheridan Avenue. Nearby alternatives include USPS locations in Powell (25 miles north) and Billings, MT (100 miles northeast)." },
    { q: "I work in Yellowstone tourism — can you accommodate my schedule?", a: "Yes. We understand that summer is the busiest season for Cody tourism workers. You can start your online order anytime — even at 10 PM after the rodeo or between guiding tours. The acceptance visit needs to happen during business hours, but the rest is on your schedule." },
    { q: "How do summer tourist crowds affect passport acceptance?", a: "Cody's population triples in summer with Yellowstone tourists, and acceptance facility appointments fill up quickly. During June through September, we recommend booking your post office or county clerk appointment 2-3 weeks ahead of when you plan to ship documents." },
    { q: "What documents do Cody applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent. We provide a Park County-specific checklist." },
    { q: "Can I get a passport photo in Cody?", a: "Yes. The Cody Post Office offers limited passport photo service. UPS Store on Sheridan Avenue and Walmart (321 Yellowstone Ave) also provide passport photos. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "What is the best price for expedited passport service in Cody?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
  ],
  photoLocations: [
    { name: "Cody Main Post Office Photos", address: "1301 Stampede Ave, Cody, WY 82414", hours: "Mon–Fri 9 AM – 3:30 PM (limited availability)", website: "https://tools.usps.com/find-location.htm", websiteLabel: "USPS Location" },
    { name: "UPS Store — Cody", address: "1531 Sheridan Ave, Cody, WY 82414", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM", website: "https://www.theupsstore.com/", websiteLabel: "UPS Store" },
    { name: "Walmart — Cody", address: "321 Yellowstone Ave, Cody, WY 82414", hours: "Daily 6 AM – 11 PM", website: "https://www.walmart.com/cp/passport-photos/1055304", websiteLabel: "Walmart Photo" },
  ],
  dmvLocations: [
    {
      name: "Park County Treasurer — Motor Vehicle Division",
      address: "1002 Sheridan Ave, Cody, WY 82414",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Courthouse location. Appointment recommended.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "COD",
      name: "Yellowstone Regional Airport",
      distance: "About 2 miles east of downtown Cody (5 minutes via Yellowstone Ave)",
      address: "2101 Airport Rd, Cody, WY 82414",
      note: "Scheduled flights to Denver (DEN) and Salt Lake City (SLC). Seasonal schedule varies — more flights in summer. Both connect to international gateways.",
      flightUrl: "https://www.flyyra.com/",
      flightLabel: "YRA Airport Website",
      featured: true,
    },
    {
      code: "BIL",
      name: "Billings Logan International Airport",
      distance: "About 100 miles northeast of Cody (1.5 hours via MT-72/I-90)",
      address: "1901 Terminal Cir, Billings, MT 59105",
      note: "Larger Montana airport with more flight options including connections to Minneapolis, Denver, Seattle, and Salt Lake City.",
      flightUrl: "https://www.flybillings.com/",
      flightLabel: "BIL Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Wyoming birth certificates from the Wyoming Department of Health Vital Statistics Services.",
      url: "https://health.wyo.gov/admin/vitalstatistics/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Park County Clerk. Certified copies for name changes and passport applications.",
      url: "https://www.parkcounty-wy.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Park County District Court.",
      url: "https://www.parkcounty-wy.gov/",
    },
  ],
};